/**
 * @generated SignedSource<<1da60f2dfe889658c14b19294505d35c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateForumInput = {
  description?: string | null | undefined;
  guidelines?: string | null | undefined;
  icon?: any | null | undefined;
  orderingPriority?: number | null | undefined;
  shortDescription?: string | null | undefined;
  slug?: string | null | undefined;
  title?: string | null | undefined;
};
export type ForumEditPageMutation$variables = {
  id: string;
  input: UpdateForumInput;
};
export type ForumEditPageMutation$data = {
  readonly updateForum: {
    readonly node: {
      readonly guidelines: string | null | undefined;
      readonly icon: any | null | undefined;
      readonly id: string;
      readonly orderingPriority: number;
      readonly shortDescription: string;
      readonly slug: string;
      readonly title: string;
    };
  };
};
export type ForumEditPageMutation = {
  response: ForumEditPageMutation$data;
  variables: ForumEditPageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ForumEdge",
    "kind": "LinkedField",
    "name": "updateForum",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Forum",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "guidelines",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "icon",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "orderingPriority",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ForumEditPageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ForumEditPageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "59cc6184fd6f84fab86e19b74204c184",
    "id": null,
    "metadata": {},
    "name": "ForumEditPageMutation",
    "operationKind": "mutation",
    "text": "mutation ForumEditPageMutation(\n  $id: ID!\n  $input: UpdateForumInput!\n) {\n  updateForum(id: $id, input: $input) {\n    node {\n      id\n      title\n      shortDescription\n      guidelines\n      slug\n      icon\n      orderingPriority\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6fcc9daebe44949ff723720545e05424";

export default node;
